import React from 'react';
import moment from 'moment';
import { CalendarStrings, DatePicker } from "@fluentui/react-datepicker-compat";
import './App.css';
import { useTranslation } from 'react-i18next';
import { Packet } from './api/Models';
import { Button, Field, Input, Spinner } from '@fluentui/react-components';
import { RowsPhotoAlbum, Photo } from 'react-photo-album';
import "react-photo-album/rows.css";
import { RestClient } from './api/RestClient';

export interface PacketSearchProps {
  packets: Packet[] | undefined;
  srchDate: Date | null | undefined;
  pageError: string | undefined;
  search: (srchDt: Date | null | undefined) => Promise<void>;
  packetDetail: (index:number) => void;
}

function PacketSearch({packets, srchDate, pageError, search, packetDetail}: PacketSearchProps) {
  const [waitSpinnerPacket, setWaitSpinnerPacket] = React.useState(false);
  const [waitSpinner, setWaitSpinner] = React.useState(false);
  const [packetID, setPacketID] = React.useState<string>('');
  const [packetError, setPacketError] = React.useState<string | undefined>();
  const { t } = useTranslation();

  const onFormatDate = (date?: Date): string => {
    return !date ? '' : moment(date).format(t('searchDateFormat'));
  };

  const startSearch = async (srchDt: Date | null | undefined): Promise<void> => {
    setWaitSpinner(true);
    try {
      await search(srchDt);
    } finally {
      setWaitSpinner(false);
    }
  }

  const goToPacket = async () => {

    if (!packetID || packetID.trim().length === 0) {
      setPacketError(t('packetIDRequired'));
      return;
    }

    setWaitSpinnerPacket(true);
    setPacketError('');
    try {
      // Reset ricerca per data
      await search(undefined);
      const packetURL = await RestClient.getInstance().gotoPacket(packetID);
      if (packetURL) {
        document.location = packetURL;
      } else {
        setPacketError(t('packetsGotoFailed'));
      }
    } catch(err) {
      console.log('Error goto packets.', err);
      setPacketError(t('packetsGotoFailed'));
    } finally {
      setWaitSpinnerPacket(false);
    }
  }

  let images: Photo[] = [];
  if (packets) {
    images = packets.map<Photo>(cp => {return {src: (process.env.REACT_APP_API_BASE_URL || '')+'/sale/imgth/'+cp.id+'/'+cp.firstimage, height: cp.height, width: cp.width}});
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <div style={{flex: '1 1 0', display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '4px'}}>
        <p className='pTitle'>{t('searchCodeTitle')}</p>
      </div>
      <div className='divGoto'>
        <Field
            style={{width: '100%', maxWidth: '400px'}}
            validationMessage={packetError}
          >
          <Input type='text'
            value={packetID}
            onChange={(ev, data) => setPacketID(data.value)}
          />
        </Field>
        <Button appearance="primary" onClick={goToPacket} style={{height: '32px'}}>{t('goToPacketBtn')}{waitSpinnerPacket && <Spinner/>}</Button>
      </div>
      <div style={{flex: '1 1 0', display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '4px'}}>
        <p className='pTitle'>{t('altSearchTitle')}</p>
      </div>
      <div style={{flex: '1 1 0', display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '4px'}}>
        <p className='pTitle'>{t('searchTitle')}</p>
      </div>
      <div style={{flex: '1 1 0', display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '4px'}}>
        <DatePicker 
          placeholder={t('searchDatePlaceHodler')}
          formatDate={onFormatDate}
          value={srchDate}
          style={{fontSize: '1.5em'}}
          strings={t('calendarString', { returnObjects: true}) as CalendarStrings}
          disabled={waitSpinner}
          onSelectDate={startSearch as (date: Date | null | undefined) => void}
        />
        {waitSpinner && <Spinner/>}
      </div>
      {pageError &&
      <div style={{flex: '1 1 0', display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '4px'}}>
        <p className='pTitle'>{pageError}</p>
      </div>}
      <RowsPhotoAlbum 
         photos={images} 
         targetRowHeight={150}
         rowConstraints={{maxPhotos: 5, singleRowMaxHeight: 200}}
         onClick={({ index }) => packetDetail(index)} 
         />
    </div>
  );
}

export default PacketSearch;
